import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServiciodepedidovigenteService {


  constructor() { }

  salidadeservicio;

  funciondelservicio(entrada, callback){
    console.log("al servicio llega esto: "+ entrada)
    this.salidadeservicio = entrada;
    callback();
  }

  origendedashboard=''


}
